import React from 'react';
import { metricKeys } from '@pulse/metrics';
import { get } from 'lodash';
import { humanize } from '@utils';
import ViewerIdCell from './ViewerIdCell';
import { getMetricOvbDisplayName } from '@src/utils/metrics';

export const viewerSessionMetricList = [
  metricKeys.StreamingPerformanceIndex,
  metricKeys.BadSession,
  metricKeys.HighRebuffering,
  metricKeys.HighStartupTime,
  metricKeys.LowBitrate,
  metricKeys.VideoPlaybackFailuresTech,
  metricKeys.VideoStartFailuresTech,
  metricKeys.HighExitBeforeVideoStart,
];

const getMetricTitle = (metric, metricList) => {
  if (metric === metricKeys.StreamingPerformanceIndex) {
    return metricList[metric].short;
  }
  const ovbDisplayName = getMetricOvbDisplayName({ metricKey: metric });
  return ovbDisplayName;
};

function buildColumns(metricList) {
  const viewerIdColumn: any = {
    title: 'Viewer ID',
    key: 'VIEWER_ID',
    dataKey: 'VIEWER_ID',
    width: 300,
    align: 'left',
    frozen: true,
    resizable: true,
    cellRenderer: ({ rowData }) => <ViewerIdCell rowData={rowData} />,
  };

  const metricColumns = viewerSessionMetricList.map((metric) => ({
    title: getMetricTitle(metric, metricList),
    key: metric,
    dataKey: metric,
    width: 120,
    align: 'left',
    dataGetter: ({ column, rowData }) => {
      const { dataKey } = column;
      const rawValue = rowData[dataKey];

      // mask low values
      if (rawValue === 'low') {
        return rawValue;
      }

      const unit = get(metricList, [dataKey, 'unit'], '');
      const value = humanize(rowData[dataKey], unit);
      return unit !== '' ? `${value} ${unit}` : value;
    },
    sortable: metric !== metricKeys.StreamingPerformanceIndex,
  }));

  return [viewerIdColumn, ...metricColumns];
}

export { buildColumns };
